import styled from 'styled-components';

export const Wrapper = styled.div`
  display: flex;
  gap: ${({ theme }) => theme.spacing[1]};
`;

export const LangButton = styled.button<{ $active: boolean }>`
  background: none;
  border: ${({ $active, theme }) =>
    $active ? `1px solid ${theme.colors.gray300}` : '1px solid transparent'};
  border-radius: ${({ theme }) => theme.radii.sm};
  padding: 2px 8px;
  font-size: ${({ theme }) => theme.fontSizes.xs};
  color: ${({ $active, theme }) =>
    $active ? theme.colors.textSecondary : theme.colors.textMuted};
  cursor: pointer;
  transition: all ${({ theme }) => theme.transitions.fast};

  &:hover {
    color: ${({ theme }) => theme.colors.textSecondary};
    border-color: ${({ theme }) => theme.colors.gray300};
  }
`;
